import { render, staticRenderFns } from "./ThreePrices.vue?vue&type=template&id=117327ae&"
import script from "./ThreePrices.vue?vue&type=script&lang=js&"
export * from "./ThreePrices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports